module.exports = __webpack_public_path__ + "static/media/caret_up.f14e461d.svg";